export default "__VITE_ASSET__WKyEBGzc__"